import React, { useEffect, useState } from "react";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification, message, Tooltip, Space } from "antd";
import { FileExcelOutlined, FileTextOutlined } from "@ant-design/icons";
import getDetalleVisitaPorTipo from "../../../../services/visitas_tecnicas/getDetalleVisitasportipoService";
import { useSelector } from "react-redux";

const Export_autorizacion_imagen = () => {
  const [dataCompleta, setDataCompleta] = useState([]);
  const [loading, setLoading] = useState(false); // Estado de carga
  const [loadingExcel, setLoadingExcel] = useState(false); // Estado para Excel
  const [loadingJson, setLoadingJson] = useState(false); // Estado para JSON
  const usernameFromState = useSelector((state) => state.auth.user);

  const fetchDetalleVisitas = async () => {
    try {
      const response = await getDetalleVisitaPorTipo(
        4,
        usernameFromState.email
      );
      const { status, results } = response;

      if (status === 200) {
        setDataCompleta(results);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch detalle visitas data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchDetalleVisitas()]);
      setLoading(false);
    };

    fetchData();
  }, []);

  const exportToExcel = async () => {
    try {
      if (dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }
      setLoadingExcel(true);

      const workbook = new ExcelJS.Workbook();

      // Cargar la plantilla de Excel
      const templateResponse = await fetch(
        "/assets/plantilla_autorizacion_imagen.xlsx"
      );
      const templateBuffer = await templateResponse.arrayBuffer();

      await workbook.xlsx.load(templateBuffer);

      const worksheet = workbook.getWorksheet(1); // Selecciona la hoja de trabajo

      let currentRow = 3; // Fila inicial

      dataCompleta.forEach((item) => {
        //Paso 1
        // Llenar columnas principales
        worksheet.getCell(`A${currentRow}`).value =
          item.detalle.id_participante || "";
        worksheet.getCell(`B${currentRow}`).value =
          item.detalle.nombre_participante || "";
        worksheet.getCell(`C${currentRow}`).value =
          item.detalle.municipio || "";
        worksheet.getCell(`D${currentRow}`).value =
          item.detalle.departamento || "";

        worksheet.getCell(`E${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_nombre") ? "SI" : "NO";
        worksheet.getCell(`F${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_fotos_videos")
            ? "SI"
            : "NO";
        worksheet.getCell(`G${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_frases") ? "SI" : "NO";
        worksheet.getCell(`H${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_declaraciones")
            ? "SI"
            : "NO";
        worksheet.getCell(`I${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_imagen") ? "SI" : "NO";
        worksheet.getCell(`J${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_entrevista") ? "SI" : "NO";
        worksheet.getCell(`K${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_archivo_audiovisual")
            ? "SI"
            : "NO";
        worksheet.getCell(`L${currentRow}`).value =
          item.detalle.autorizaciones?.includes("uso_otro") ? "SI" : "NO";

        worksheet.getCell(`M${currentRow}`).value = item.detalle.dia || "";
        worksheet.getCell(`N${currentRow}`).value = item.detalle.mes || "";
        worksheet.getCell(`O${currentRow}`).value =
          item.detalle.anio_firma || "";
        worksheet.getCell(`P${currentRow}`).value = item.detalle.fuente || "";

        worksheet.getCell(`Q${currentRow}`).value = item.name || "";
        worksheet.getCell(`R${currentRow}`).value = item.email || "";
        worksheet.getCell(`S${currentRow}`).value = item.estado || "";

        // Asegurar que `currentRow` inicie en la fila siguiente al último dato escrito
        currentRow = currentRow + 1;
      });

      // Descargar el archivo modificado
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "Informe-Autorizacion-Imagen.xlsx");
      // Cerrar notificación de carga y mostrar éxito
      notification.success({
        message: "Éxito",
        description: "Excel exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar Excel:", error);
      // Cerrar notificación de carga y mostrar éxito
      notification.error({
        message: "Error",
        description: "No se pudo exportar el Excel.",
        duration: 3,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const exportToJSON = async () => {
    try {
      if (!dataCompleta || dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3,
        });
        return;
      }

      setLoading(true);
      // Convertir data a JSON y descargar
      const jsonBlob = new Blob([JSON.stringify(dataCompleta, null, 2)], {
        type: "application/json",
      });
      saveAs(jsonBlob, "Informe-Autorizacion-Imagen.json");
      notification.success({
        message: "Éxito",
        description: "JSON exportado correctamente.",
        duration: 3,
      });
    } catch (error) {
      console.error("Error al generar JSON:", error);
      notification.error({
        message: "Error",
        description: "No se pudo exportar el JSON.",
        duration: 3,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Space>
      <Tooltip title="Exportar datos en XLSX">
        <Button
          type="default"
          icon={<FileExcelOutlined />}
          onClick={exportToExcel}
          loading={loading || loadingExcel}
          disabled={loading || loadingExcel}
          style={{
            backgroundColor: "#52c41a",
            borderColor: "#52c41a",
            color: "white",
          }}
        />
      </Tooltip>

      <Tooltip title="Exportar datos en JSON">
        <Button
          type="default"
          icon={<FileTextOutlined />}
          onClick={exportToJSON}
          loading={loading || loadingJson}
          disabled={loading || loadingJson}
          style={{
            backgroundColor: "#C2BCBC",
            borderColor: "#C2BCBC",
            color: "white",
          }}
        />
      </Tooltip>
    </Space>
  );
};

export default Export_autorizacion_imagen;
